<template>
  <div class="fixed top-4 right-4 z-[9999] flex flex-col gap-2 max-w-sm w-full">
    <TransitionGroup name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="p-4 rounded-lg shadow-lg border flex items-start gap-3 bg-white"
        :class="{
          'border-emerald-200 bg-emerald-50 text-emerald-800': toast.type === 'success',
          'border-rose-200 bg-rose-50 text-rose-800': toast.type === 'error',
          'border-blue-200 bg-blue-50 text-blue-800': toast.type === 'info',
          'border-amber-200 bg-amber-50 text-amber-800': toast.type === 'warning'
        }"
      >
        <div class="flex-shrink-0 mt-0.5">
          <CheckCircle v-if="toast.type === 'success'" class="h-5 w-5 text-emerald-600" />
          <XCircle v-else-if="toast.type === 'error'" class="h-5 w-5 text-rose-600" />
          <Info v-else-if="toast.type === 'info'" class="h-5 w-5 text-blue-600" />
          <AlertTriangle v-else class="h-5 w-5 text-amber-600" />
        </div>
        
        <div class="flex-1">
          <p class="text-sm font-medium leading-5">
            {{ toast.message }}
          </p>
        </div>

        <button 
          @click="removeToast(toast.id)"
          class="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X class="h-4 w-4" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { useToast } from '@/composables/useToast'
import { CheckCircle, XCircle, Info, AlertTriangle, X } from 'lucide-vue-next'

const { toasts, removeToast } = useToast()
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(30px);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
